const loadSolvvySnippet = () => {
    const script = document.createElement('script');
    script.src = '//cdn.solvvy.com/deflect/customization/issuu/solvvy.js';
    document.head.appendChild(script);
};

export const loadSolvvy = () => {
    if (window.location.search.includes('ds=1')) {
        return;
    }

    loadSolvvySnippet();

    document.addEventListener('solvvy_ready', () => {
        window.Solvvy.open();
        window.Solvvy.close();
        const askButton = document.querySelectorAll<HTMLButtonElement>('.solvvy-support-flow-link');
        if (askButton.length > 0) {
            askButton[0].click();
        }
    });
};

export default loadSolvvy;
